var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _path3, _path4, _rect, _circle101, _rect2, _path5, _rect3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle102, _polygon, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawGridDesignObmd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ac3e78f9-fa01-469d-9115-1cc97ea9f5ff",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 888,
    height: 459.87333,
    viewBox: "0 0 888 459.87333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grid_design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M761.29659,303.61783a2.82151,2.82151,0,0,0,2.82152-2.82152V270.70007a2.79444,2.79444,0,0,0-3.762-2.64874v-34.031a9.405,9.405,0,0,0-9.40507-9.40507H443.40507A9.405,9.405,0,0,0,434,234.02028V646.903a9.4051,9.4051,0,0,0,9.40507,9.40508H750.951a9.4051,9.4051,0,0,0,9.40507-9.40508V345.76788a2.79442,2.79442,0,0,0,3.762-2.64874V313.0229a2.79442,2.79442,0,0,0-3.762-2.64873V303.445A2.79526,2.79526,0,0,0,761.29659,303.61783Z",
    transform: "translate(-156 -220.06334)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M732.14087,242.95509a9.40508,9.40508,0,0,1,9.40509,9.40509v376.203a9.40509,9.40509,0,0,1-9.40509,9.405H462.21518a9.40511,9.40511,0,0,1-9.40506-9.405v-376.203a9.40509,9.40509,0,0,1,9.40506-9.40509H732.14087",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 94.45584,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 121.20846,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 147.96107,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 174.71369,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 201.46631,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 228.21893,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 254.97155,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 281.72417,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 308.47678,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.18326,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.60424,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.02522,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.4462,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.86718,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.28816,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.70914,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.13012,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.5511,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.97209,
    cy: 335.2294,
    r: 5.21949,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.08019,561.34349l-14.31326-12.33063a237.79587,237.79587,0,0,1,3.16481-26.61561l7.87708,3.2752-7.32843-6.31327c2.03026-10.86892,4.06294-17.938,4.06294-17.938s28.88176,25.3296,45.148,56.347l-6.90762,23.23814,10.6751-15.40419a96.20553,96.20553,0,0,1,4.1636,11.35061c11.44974,39.02762,7.98531,74.40521-7.73807,79.01807s-37.75151-23.28585-49.20125-62.31348c-3.54954-12.099-4.526-25.56013-4.18537-38.37707Z",
    transform: "translate(-156 -220.06334)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.56976,591.97711l-18.62651-3.157a237.7952,237.7952,0,0,1-11.04843-24.42l8.43609-1.268-9.53681-1.61636C157.91394,551.162,156,544.05985,156,544.05985s37.817,6.75425,67.77457,24.89846l6.09859,23.46345,1.17592-18.70466a96.206,96.206,0,0,1,9.43138,7.56447c29.97492,27.491,45.29594,59.56659,34.22041,71.64283s-44.35348-.41992-74.32841-27.91093c-9.29252-8.52249-17.08648-19.54115-23.42-30.68908Z",
    transform: "translate(-156 -220.06334)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 435.96038,
    width: 888,
    height: 2.24072,
    fill: "#3f3d56"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.17804,
    cy: 13.95694,
    r: 3.76203,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 315.84012,
    y: 173.84321,
    width: 193.15806,
    height: 86.5731,
    rx: 2.82152,
    fill: "#5850ec"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M604.304,459.76411a1.88317,1.88317,0,0,0-1.881,1.881v6.2226a1.88317,1.88317,0,0,0,1.881,1.881H635.2043a1.88346,1.88346,0,0,0,1.881-1.881v-6.2226a1.88346,1.88346,0,0,0-1.881-1.881Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 330.66842,
    y: 29.94557,
    width: 221.95976,
    height: 16.92913,
    rx: 5.64304,
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M624.923,259.414H569.43307a.94051.94051,0,1,1,0-1.881H624.923a.94051.94051,0,1,1,0,1.881Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M642.79265,409.89517a1.881,1.881,0,0,1,1.881,1.881v3.762a1.881,1.881,0,0,1-1.881,1.881H494.19248a1.881,1.881,0,0,1-1.881-1.881v-3.762a1.881,1.881,0,0,1,1.881-1.881H642.79265",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M642.79265,427.76481a1.881,1.881,0,0,1,1.881,1.881v3.762a1.881,1.881,0,0,1-1.881,1.881H494.19248a1.881,1.881,0,0,1-1.881-1.881v-3.762a1.881,1.881,0,0,1,1.881-1.881H642.79265",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M642.79265,445.63445a1.881,1.881,0,0,1,1.881,1.881v3.762a1.881,1.881,0,0,1-1.881,1.881H494.19248a1.881,1.881,0,0,1-1.881-1.881v-3.762a1.881,1.881,0,0,1,1.881-1.881H642.79265",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M398.60847,339.135A119.06385,119.06385,0,0,1,282.0137,458.18564c-.82209.0211-1.6548.03165-2.4769.03165s-1.6548-.01055-2.477-.03165A119.074,119.074,0,1,1,398.60847,339.135Z",
    transform: "translate(-156 -220.06334)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M285.17574,656.33984c-.8221.0211-4.81684.03165-5.63894.03165s-4.81684-.01055-5.639-.03165l5.639-315.47624Z",
    transform: "translate(-156 -220.06334)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M719.91426,599.51912a17.777,17.777,0,1,1-2.75509-9.52288A17.82523,17.82523,0,0,1,719.91426,599.51912Z",
    transform: "translate(-156 -220.06334)",
    fill: "#5850ec"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M717.15917,589.99624l-17.54828,17.545c-1.10292-1.7075-7.2475-9.6428-7.2475-9.6428a24.86483,24.86483,0,0,1,2.51524-2.22029l5.09528,6.79373,15.13028-15.13029A17.75273,17.75273,0,0,1,717.15917,589.99624Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M843,453.30812s-12,9-8,69,4,70,4,70-6,27,4,37c0,0,9,5,6,8l15,2s-4-1,2-7,0-18,0-18l3-55,11-53,13,70s-5,47,2,54,5,12,5,12h15s-5-5,4-9,5-33,5-33,7-111,4-125-13-30-13-30Z",
    transform: "translate(-156 -220.06334)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5,633.80812l-9,12-9,14s-17,22,4,20,17-9,17-9,11,1,11-8-3.75984-25.70342-3.75984-25.70342Z",
    transform: "translate(-156 -220.06334)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M909.5,633.80812l9,12,9,14s17,22-4,20-17-9-17-9-11,1-11-8,3.75984-25.70342,3.75984-25.70342Z",
    transform: "translate(-156 -220.06334)",
    fill: "#2f2e41"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.5,
    cy: 74.74478,
    r: 22,
    fill: "#ffb9b9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "714 88.245 713 110.245 727 132.245 745 107.245 741 89.245 714 88.245",
    fill: "#ffb9b9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M923,402.30812a225.81687,225.81687,0,0,1-5,44l2,4s-15.46,2.45-33,4.32007c-1.32.13989-2.66.2799-4,.41992-16.78,1.65991-34.52,2.6-42,.26l2-5s-4-10,2-32c0,0-2-12,0-20,1.37613-5.50453-11.04587-34.36876-16.00838-45.56011a5.60619,5.60619,0,0,1,2.16224-7.02944L869.38,321.88808a25.40835,25.40835,0,0,0,13.62,5.54,22.47321,22.47321,0,0,0,4-.06994,24.95908,24.95908,0,0,0,12.8-5.47009l17.2,9.42,19.15523,13.68231a3.27052,3.27052,0,0,1,1.2582,3.50754Z",
    transform: "translate(-156 -220.06334)",
    fill: "#575a89"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M887,327.35817v127.95h-4v-127.88A22.47321,22.47321,0,0,0,887,327.35817Z",
    transform: "translate(-156 -220.06334)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M894.5,355.80812v11.5a11.5,11.5,0,0,0,23,0v-11.5Z",
    transform: "translate(-156 -220.06334)",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M887.14994,284.73745s-3.511-.41928-3.3712-1.58961c0,0-12.19678-1.83551-17.84538,3.021s-3.5-3.196-3.5-3.196-12.17473-7.389-.943-11.98274l1.03056,1.31008s2.75993-3.23144,11.09195-3.42343l-1.03056-1.31008s.13976-1.17032,5.99138-.47151,21.76461-3.33589,21.39754,9.67742c0,0,9.78187-2.39287,8.38424,9.31036s-3.26676,17.41507-3.26676,17.41507-1.64183-6.13114-6.7424-3.17922S887.14994,284.73745,887.14994,284.73745Z",
    transform: "translate(-156 -220.06334)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M913.208,495.63429a2.0026,2.0026,0,0,0-2,2V599.8921a2.0026,2.0026,0,0,0,2,2H994a2.0026,2.0026,0,0,0,2-2V497.63429a2.0026,2.0026,0,0,0-2-2Z",
    transform: "translate(-156 -220.06334)",
    fill: "#5850ec"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M939.0166,569.76613a1.00067,1.00067,0,0,0-1,1v7.709a1.00067,1.00067,0,0,0,1,1h29.17481a1.00068,1.00068,0,0,0,1-1v-7.709a1.00068,1.00068,0,0,0-1-1Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M946.5,480.80812v6s3,20-8,19-5-21-5-21l1-5Z",
    transform: "translate(-156 -220.06334)",
    fill: "#ffb9b9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M834.5,475.80812v6s3,20-8,19-5-21-5-21l1-5Z",
    transform: "translate(-156 -220.06334)",
    fill: "#ffb9b9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M951.86,431.25807l-4.36,38.55005s4,13,0,13-17,1-16-3,2-10,2-10l-3-46-9-28,8.61972-46.9296a3.27054,3.27054,0,0,1,2.42226-2.58174l2.471-.61878a3.27056,3.27056,0,0,1,2.818.60322h0a3.25216,3.25216,0,0,1,.99684,1.31484c1.52381,3.68687,7.91465,19.42445,9.67217,28.212,1.05,5.24,2.37,16.26,3.39,25.55005.93,8.42993,1.61,15.45,1.61,15.45Z",
    transform: "translate(-156 -220.06334)",
    fill: "#575a89"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M831.95506,346.44852h0a5.60935,5.60935,0,0,0-3.20029.62836l-1.5718.83605a5.59014,5.59014,0,0,0-2.5189,2.735c-1.64933,3.84642-5.16407,13.21043-5.16407,23.16023,0,13-3,48-3,48v47s-5,9,2,9,21,2,20-2-3-10-3-10l3-46,10-36-11.81887-33.63833A5.60933,5.60933,0,0,0,831.95506,346.44852Z",
    transform: "translate(-156 -220.06334)",
    fill: "#575a89"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M985.104,519.30812h-63a1,1,0,0,1,0-2h63a1,1,0,0,1,0,2Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M985.104,529.30812h-63a1,1,0,0,1,0-2h63a1,1,0,0,1,0,2Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M985.104,539.30812h-63a1,1,0,0,1,0-2h63a1,1,0,0,1,0,2Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M985.104,549.30812h-63a1,1,0,0,1,0-2h63a1,1,0,0,1,0,2Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M985.104,559.30812h-63a1,1,0,0,1,0-2h63a1,1,0,0,1,0,2Z",
    transform: "translate(-156 -220.06334)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawGridDesignObmd);
export default __webpack_public_path__ + "static/media/undraw_grid_design_obmd.be9e9075.svg";
export { ForwardRef as ReactComponent };